/**
 * Cross-domain redirect utilities for routing users to the correct app.
 *
 * Production domains:
 * - app.scrivio.nl → behandelaar app
 * - mijn.scrivio.nl → client portal
 *
 * Local development:
 * - Redirects are skipped, only warnings are logged
 * - Use ?mode=client to test portal behavior
 */

const PORTAL_DOMAIN = 'mijn.scrivio.nl'
const APP_DOMAIN = 'app.scrivio.nl'

/**
 * Check if running in local development mode
 */
function isLocalDevelopment(): boolean {
  const hostname = window.location.hostname
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

/**
 * Redirect user to the client portal (mijn.scrivio.nl)
 * In development, logs a warning instead of redirecting.
 *
 * @param path Optional path to preserve (e.g., '/dashboard')
 */
export function redirectToPortal(path?: string): void {
  if (isLocalDevelopment()) {
    console.warn('[Auth] Client user accessing behandelaar app - would redirect to portal in production')
    return
  }

  const url = new URL(`https://${PORTAL_DOMAIN}`)
  if (path) {
    url.pathname = path
  }
  console.log('[Auth] Redirecting client to portal:', url.toString())
  window.location.href = url.toString()
}

/**
 * Redirect user to the behandelaar app (app.scrivio.nl)
 * In development, logs a warning instead of redirecting.
 *
 * @param path Optional path to preserve (e.g., '/dashboard')
 */
export function redirectToApp(path?: string): void {
  if (isLocalDevelopment()) {
    console.warn('[Auth] Behandelaar user accessing portal - would redirect to app in production')
    return
  }

  const url = new URL(`https://${APP_DOMAIN}`)
  if (path) {
    url.pathname = path
  }
  console.log('[Auth] Redirecting behandelaar to app:', url.toString())
  window.location.href = url.toString()
}
